// extracted by mini-css-extract-plugin
export default {"icon":"CustomIcon_icon__NfI6g","notification":"CustomIcon_notification__bPzUK"};